<template>
  <span class="recipe-total-info">
    <font-awesome-icon
      v-if="showInfoIcon"
      icon="info-circle"
      v-tooltip="tooltipConfig"
      class="recipe-total-info__icon"
    />
    <span class="recipe-total-info__total">
      <v-price :price="displayPrice" />
    </span>
  </span>
</template>

<script>
import VPrice from '@/components/v3/elements/VPrice';

export default {
  name: 'VRecipeTotalInfo',
  components: {
    VPrice,
  },
  props: {
    salesPrice: {
      type: Number,
      default: 0,
    },
    targetCogsAmount: {
      type: Number,
      default: 0,
    },
    targetCogsPercent: {
      type: Number,
      default: 0,
    },
    showInfoIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayPrice() {
      return this.targetCogsAmount;
    },
    tooltipContent() {
      if (!this.showInfoIcon) return '';

      return `
        <div class="recipe-tooltip">
          <div class="recipe-tooltip__item">
            <strong>Sales Price:</strong>
            <span>$${(this.salesPrice || 0).toFixed(2)}</span>
          </div>
          <div class="recipe-tooltip__item">
            <strong>Target COGS($):</strong>
            <span>$${(this.targetCogsAmount || 0).toFixed(2)}</span>
          </div>
          <div class="recipe-tooltip__item">
            <strong>Target COGS(%):</strong>
            <span>${this.targetCogsPercent || 0}%</span>
          </div>
        </div>
      `;
    },
    tooltipConfig() {
      return {
        html: true,
        classes: ['tooltip-general'],
        content: this.tooltipContent,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.recipe-total-info {
  display: inline-flex;
  align-items: center;
  @include font-size(18px);
  font-weight: 600;
  vertical-align: middle;

  &__text {
    margin-right: 4px;
    color: #6c7995;
    @include font-size(12px);
  }

  &__icon {
    color: #6c7995;
    cursor: pointer;
    margin-right: 4px;
    font-size: 16px;
  }

  &__total {
    color: #252631;
    @include font-size(20px);

    :deep(.v-price__price) {
      font-size: 1.25rem !important;
      font-weight: 600 !important;
    }
  }
}
</style>

<style lang="scss">
.recipe-tooltip {
  min-width: 180px;

  &__item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      margin-right: 8px;
    }
  }
}
</style>
